import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AuditPage, type AuditSearch } from "../../../components/admin/audit/AuditPage";

// The Audit log (R3-A10; PLAN §6.3 `GET /audit`, §8.10; STATUS O5). Filters and the open change
// live in the URL (`?person=&tool=&from=&to=&id=`), like the API's own.

const DAY = /^\d{4}-\d{2}-\d{2}$/;

function str(v: unknown): string | undefined {
  return typeof v === "string" && v ? v : undefined;
}

export const Route = createFileRoute("/_app/admin/audit")({
  validateSearch: (s: Record<string, unknown>): AuditSearch => {
    const out: AuditSearch = {};
    for (const key of ["person", "tool", "id"] as const) {
      const v = str(s[key]);
      if (v) out[key] = v;
    }
    for (const key of ["from", "to"] as const) {
      const v = str(s[key]);
      if (v && DAY.test(v)) out[key] = v;
    }
    return out;
  },
  component: Audit,
});

function Audit() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <AuditPage
      search={search}
      onSearch={(next, opts) =>
        navigate({
          search: Object.fromEntries(
            Object.entries(next).filter(([, v]) => v !== undefined && v !== ""),
          ) as AuditSearch,
          replace: !opts?.push,
        })
      }
    />
  );
}
